import React from "react";
import "./CoreVirtuesValues.css";
import senses from "../../assets/senses.png";
import changes from "../../assets/changes.png";
import trust from "../../assets/trust.png";
import { useTranslation } from "react-i18next";

const CoreVirtuesValues = () => {
  const { t } = useTranslation("global");

  return (
    <section
      className="core-virtues-wrapper"
      aria-labelledby="core-values-heading"
    >
      <header className="core-heading">
        <h2 id="core-values-heading">{t("coreVirtuesValues.heading")}</h2>
        <h3>{t("coreVirtuesValues.subheading")}</h3>
      </header>
      <div className="core-virtues-container">
        <article className="core-virtues-item">
          <div className="virtue-image-container">
            <img
              src={senses || "/placeholder.svg"}
              alt={t("coreVirtuesValues.senseOfOwnership.imageAlt")}
              className="virtue-image"
              loading="lazy"
              width="80"
              height="80"
              title={t("coreVirtuesValues.senseOfOwnership.title")}
            />
          </div>
          <h4>{t("coreVirtuesValues.senseOfOwnership.title")}</h4>
          <p>{t("coreVirtuesValues.senseOfOwnership.description")}</p>
        </article>
        <article className="core-virtues-item">
          <div className="virtue-image-container">
            <img
              src={changes || "/placeholder.svg"}
              alt={t("coreVirtuesValues.constantChanges.imageAlt")}
              className="virtue-image"
              loading="lazy"
              width="80"
              height="80"
              title={t("coreVirtuesValues.constantChanges.title")}
            />
          </div>
          <h4>{t("coreVirtuesValues.constantChanges.title")}</h4>
          <p>{t("coreVirtuesValues.constantChanges.description")}</p>
        </article>
        <article className="core-virtues-item">
          <div className="virtue-image-container">
            <img
              src={trust || "/placeholder.svg"}
              alt={t("coreVirtuesValues.trust.imageAlt")}
              className="virtue-image"
              loading="lazy"
              width="80"
              height="80"
              title={t("coreVirtuesValues.trust.title")}
            />
          </div>
          <h4>{t("coreVirtuesValues.trust.title")}</h4>
          <p>{t("coreVirtuesValues.trust.description")}</p>
        </article>
      </div>
    </section>
  );
};

export default CoreVirtuesValues;
